import { FormBuilder, Validators } from "@angular/forms";
import { IAddressModel } from "lib-core-shared";

import { AddressFormMapping } from "../models/mappings/address-form-mapping";
import { AddressRequestMappingModel } from "../models/mappings/address-request-mapping";

export class AddressViewModel implements IAddressModel {
    public formMapping: AddressFormMapping;
    public addressRequestMapping: AddressRequestMappingModel;
    constructor(private readonly fb: FormBuilder) {
        this.formMapping = new AddressFormMapping();
        this.addressRequestMapping = new AddressRequestMappingModel();
    }
    country!: string;
    countyState!: string;
    countryName!: string;
    countryCode!: string;
    addressLine1!: string;
    addressLine2!: string;
    townCity!: string;
    postalCode!: string;
    isVerified!: boolean;

    form = () => this.fb.group({
        id: [0],
        addressLine1: [null, Validators.required],
        addressLine2: [null],
        townCity: [null],
        countyState: [null],
        postalCode: [null, Validators.required],
        isVerified: [false]
    })
}